var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow down",
    d: "M23.875 0C22.2181 0 20.875 1.34315 20.875 3V30.8042C20.875 33.4769 17.6436 34.8154 15.7537 32.9256L5.51518 22.6871C4.33627 21.5081 2.42228 21.5166 1.25385 22.7059L1.08394 22.8788C-0.0699592 24.0534 -0.0616178 25.9384 1.10263 27.1026L21.8787 47.8787C23.0503 49.0503 24.9497 49.0503 26.1213 47.8787L46.8974 27.1026C48.0616 25.9384 48.07 24.0534 46.9161 22.8788L46.7462 22.7059C45.5777 21.5166 43.6637 21.5081 42.4848 22.6871L32.2463 32.9255C30.3564 34.8154 27.125 33.4769 27.125 30.8042V3C27.125 1.34315 25.7819 0 24.125 0H23.875Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrow down.4c485dc45a6b3d3549609d392b4130fd.svg";
export { ForwardRef as ReactComponent };